import React, { useState } from 'react';
import {
  Container, Typography, Box, Stack, Button,
} from '@mui/material';
import StyledBox, {
  StyledImgBox,
} from 'views/rebranded-module/HomeViewV2/components/UI/HeroSection/HeroSection.styles';
import dynamic from 'next/dynamic';
import { Typography700 } from 'views/common/components';
import { MainWidgetV2, Video } from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const BookNowOverlay = dynamic(() => import('views/rebranded-module/HomeViewV2/components/UI/BookNowOverlay').then(
  (file) => file.BookNowOverlay,
));

const HeroSection = (props) => {
  const [isOverlayOpen, setOverlayOpen] = useState(false);
  const content = useContent('HomePage');
  const { initWidgetData } = props;
  const handleOpenOverlayBookingClick = (event) => {
    setOverlayOpen(true);
    event.currentTarget.blur(); // Remove focus immediately after click
  };
  return (
    <StyledBox>
      <Box className="HSVideoWrapper">
        <Video
          videoSrc={content.heroVideo.url}
          fallbackImg={{
            src: content.heroVideoFallbackImage.url,
            alt: content.heroVideoFallbackImage.alt,
            width: '100%',
            height: '1080px',
          }}
          className="HSVideo"
        />

        <Box className="HSWidgetContainer">
          <MainWidgetV2 rentalWidgetInitData={initWidgetData} />
        </Box>
      </Box>

      <Box className="HSTextContent" pb={10}>
        <Container className="HSTextContentContainer">
          <Stack
            gap={{
              xs: 3.5,
              sm: 3.5,
              md: 3.5,
              lg: 5,
            }}>
            <Box display="flex" justifyContent="center">
              <StyledImgBox
                image={{
                  src: content.logoIcon.url,
                  alt: content.logoIcon.alt,
                }}
                imgHeight="80px"
                imgWidth="80px"
              />
            </Box>
            <Typography700 variant="h3" component="h2" className="HSTextTitle">
              {content.headerText}
            </Typography700>
            <Typography
              variant="body1"
              className="HSText"
              dangerouslySetInnerHTML={{
                __html: content.subHeaderText,
              }}
            />
          </Stack>
        </Container>
      </Box>
      <Button
        variant="contained"
        color="primary"
        size="large"
        className="HSFixedButton"
        onClick={handleOpenOverlayBookingClick}>
        {content.bookingOverlayButton}
      </Button>
      {isOverlayOpen && (
        <BookNowOverlay
          open={isOverlayOpen}
          onClose={() => setOverlayOpen(false)}
        />
      )}
    </StyledBox>
  );
};
export { HeroSection };
